import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function EditCleaningRound() {
  const { id } = useParams();
  const navigate = useNavigate();

   const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  // ================================
  // BASIC INFO
  // ================================
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  // ================================
  // LOCATION
  // ================================
  const [suburb, setSuburb] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");

  // ================================
  // ROUND METRICS
  // ================================
  const [clientsCount, setClientsCount] = useState("");
  const [totalCutValue, setTotalCutValue] = useState("");
  const [yearlyRevenue, setYearlyRevenue] = useState("");

  // ================================
  // PRICE
  // ================================
  const [price, setPrice] = useState("");

  // ================================
  // LOAD ROUND
  // ================================
  useEffect(() => {
    async function load() {
      try {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user"));

        if (!user?.id) {
          navigate("/my-listings");
          return;
        }

     const res = await fetch(
  `${API_BASE_URL}/api/cleaning/rounds/${id}`,
  {
    headers: { Authorization: `Bearer ${token}` },
  }
);

        const data = await res.json();

        if (!data?.success || !data?.listing) {
          alert("Round not found");
          navigate("/my-listings");
          return;
        }

        const r = data.listing;

     

        if (String(r.user_id) !== String(user.id)) {
          alert("You cannot edit this round.");
          navigate("/my-listings");
          return;
        }

        // PREFILL
        setTitle(r.title || "");
        setDescription(r.description || "");
        setSuburb(r.suburb || "");
        setState(r.state || "");
        setPostcode(r.postcode || "");
        setClientsCount(r.clients_count || "");
        setTotalCutValue(r.total_cut_value || "");
        setYearlyRevenue(r.yearly_revenue || "");
        setPrice(r.price || "");
      } catch (err) {
        console.error("❌ LOAD CLEANING ROUND ERROR:", err);
        navigate("/my-listings");
      }
    }

    load();
}, [id, navigate]);

  // ================================
  // SAVE
  // ================================
const handleSave = async (e) => {
  e.preventDefault();
  setMessage("");

  if (saving) return;
  setSaving(true);
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(
        `${API_BASE_URL}/api/cleaning/rounds/edit/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            title,
            description,
            suburb,
            state,
            postcode,
            clients_count: clientsCount,
            total_cut_value: totalCutValue,
            yearly_revenue: yearlyRevenue,
            price,
          }),
        }
      );

      const data = await res.json().catch(() => ({}));

  if (!res.ok) {
  setMessage(data?.error || "❌ Failed to save changes");
  setSaving(false);
  return;
}

      alert("Cleaning round updated");
      navigate("/my-listings");
    } catch (err) {
      console.error("❌ SAVE CLEANING ROUND ERROR:", err);
      setMessage("❌ Failed to save changes");
       setSaving(false);
    }
  };

  // ================================
  // UI (MATCH CLEANING LISTINGS)
  // ================================
  return (
    <div style={container}>
      <h2 style={pageHeader}>Edit Cleaning Round</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            fontWeight: 600,
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSave} style={form}>
        {/* BASIC */}
        <h3 style={sectionHeader}>Round Details</h3>

        <label style={labelBold}>Title</label>
        <input style={input} required value={title} onChange={(e) => setTitle(e.target.value)} />

        <label style={labelBold}>Description</label>
        <textarea style={input} value={description} onChange={(e) => setDescription(e.target.value)} />

        {/* LOCATION */}
        <h3 style={sectionHeaderBlue}>Location</h3>

        <label style={labelBold}>Suburb</label>
        <input style={input} required value={suburb} onChange={(e) => setSuburb(e.target.value)} />

        <label style={labelBold}>State</label>
        <select style={input} required value={state} onChange={(e) => setState(e.target.value)}>
          <option value="">Select</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="NT">NT</option>
          <option value="TAS">TAS</option>
          <option value="ACT">ACT</option>
        </select>

        <label style={labelBold}>Postcode</label>
        <input style={input} required value={postcode} onChange={(e) => setPostcode(e.target.value)} />

        {/* METRICS */}
        <h3 style={sectionHeaderPurple}>Round Metrics</h3>

        <label style={labelBold}>Clients Count</label>
        <input type="number" style={input} value={clientsCount} onChange={(e) => setClientsCount(e.target.value)} />

        <label style={labelBold}>Total Cut Value ($)</label>
        <input type="number" style={input} value={totalCutValue} onChange={(e) => setTotalCutValue(e.target.value)} />

        <label style={labelBold}>Yearly Revenue ($)</label>
        <input type="number" style={input} value={yearlyRevenue} onChange={(e) => setYearlyRevenue(e.target.value)} />

        {/* PRICE */}
        <h3 style={sectionHeaderOrange}>Sale Price</h3>

        <label style={labelBold}>Price ($)</label>
        <input type="number" style={input} required value={price} onChange={(e) => setPrice(e.target.value)} />
<button type="submit" style={button} disabled={saving}>
  {saving ? "Saving..." : "Save Changes"}
</button>
      </form>
    </div>
  );
}

/* ================================
   STYLES (COPIED FROM EDIT LISTING)
================================ */

const container = {
  maxWidth: "650px",
  margin: "40px auto",
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const pageHeader = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#2e7d32",
  fontWeight: "bold",
};

const form = { display: "flex", flexDirection: "column", gap: "20px" };
const input = { padding: "10px", borderRadius: "6px", border: "1px solid #ccc" };
const labelBold = { fontWeight: "bold" };

const sectionHeader = { borderBottom: "2px solid #4CAF50", paddingBottom: "6px" };
const sectionHeaderBlue = { borderBottom: "2px solid #1976D2", paddingBottom: "6px" };
const sectionHeaderPurple = { borderBottom: "2px solid #9C27B0", paddingBottom: "6px" };
const sectionHeaderOrange = { borderBottom: "2px solid #FF9800", paddingBottom: "6px" };

const button = {
  padding: "14px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};
